import { ReactNode } from "react";

type ContentSwitchProps = {
    index: number;
    onChange: (index: number) => void;
    options: { title: ReactNode, content: ReactNode }[];
}

export function ContentSwitch({ index, onChange, options }: ContentSwitchProps) {
    return <div className="content-switch">
        <div className="content-switch-titles">
            {options.map(({ title }, i) => <a key={i} className={`content-switch-title ${index === i ? "active" : ""}`} onClick={() => onChange(i)}>
                <div className="block" />
                <span>{title}</span>
            </a>)}
        </div>
        <div className="content-switch-inner">
            {options.map(({ content }, i) => <div
                key={i}
                className={index === i ? "active" : ""}
                style={{ left: `${-index * 100 + (index < i ? -50 : index > i ? 50 : 0)}%` }}
            >
                {content}
            </div>)}
        </div>
    </div>;
}
